<div class="p-auth -pattern" [style.background-image]="background">
  <img *ngIf="!background" src="assets/affiliate/auth-bg-2.svg" alt="" class="p-auth__img-top" />
  <img *ngIf="!background" src="assets/affiliate/auth-bg-1.svg" alt="" class="p-auth__img-bottom" />
  <div class="p-auth__inner">
    <router-outlet></router-outlet>
    <div *ngIf="!hideCopyright" class="p-auth__copyright">
      <span [style.color]="textColor" class="font-body-4">© IREV, {{currentYear}}.</span>
    </div>
  </div>
</div>

<!-- Section: Float Notifications -->
<p500-ui-float-notifications></p500-ui-float-notifications>
<!-- End of Section: Float Notifications -->
<!-- Google Analytics/Amplitude -->
<gtd-analytics></gtd-analytics>
